export default __webpack_public_path__ + "img/component-info-card.66aa97ea.png";